import { render } from "./RecieveInvitaitonView.vue?vue&type=template&id=461aa2da&ts=true"
import script from "./RecieveInvitaitonView.vue?vue&type=script&lang=ts"
export * from "./RecieveInvitaitonView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__